import McSearchBar from './McSearchBar.vue'

McSearchBar.install = function(Vue){
    Vue.component(McSearchBar.name,McSearchBar)
}

export default McSearchBar